export default (dateString) => {
  const date = new Date(dateString);
  return new Intl.DateTimeFormat(document.documentElement.lang, {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  }).format(date);
};
